<dex-tranche-details-standalone
    [tranche]="widgetImpl.$tranche()"
    [isEmbedded]="false"
    [isCollapsed]="!!widgetImpl.$features().COLLAPSED"
    [isExpandCollapseEnabled]="!!widgetImpl.$features().SUPPORTS_EXPAND_COLLAPSE"
    [isSymbolClickable]="true"
    (toggleCollapsed)="handleToggleCollapsed()"
    (symbolClick)="handleSymbolClick($event)"
    (tradeClick)="handleTradeClick($event)">
</dex-tranche-details-standalone>
